import React, { useState } from 'react';
import {
  Paper,
  Typography,
  Box,
  Button,
  Stack,
  Alert,
} from '@mui/material';
import { Code as CodeIcon, ArrowDownward as ArrowDownwardIcon } from '@mui/icons-material';
import { useBuild } from '../contexts/BuildContext';
import BackendCallDialog from '../components/BackendCallDialog';

const RankingInfoColumn = () => {
  const { rankingResults, rankingLastCall } = useBuild();
  const [backendCallDialogOpen, setBackendCallDialogOpen] = useState(false);

  const handleOpenBackendCallDialog = () => {
    setBackendCallDialogOpen(true);
  };

  const handleCloseBackendCallDialog = () => {
    setBackendCallDialogOpen(false);
  };

  const renderInfo = () => {
    if (!rankingResults) {
      return (
        <Typography variant="body2" color="text.secondary">
          No ranking executed yet.
        </Typography>
      );
    }

    if (rankingResults?.error) {
      return (
        <Stack spacing={2}>
          <Button
            variant="outlined"
            startIcon={<CodeIcon />}
            onClick={handleOpenBackendCallDialog}
            fullWidth
          >
            Backend Call
          </Button>
          <Alert severity="error">
            <Typography variant="subtitle2" gutterBottom>
              Ranking Error
            </Typography>
            <Typography variant="body2">
              {rankingResults.error}
            </Typography>
          </Alert>
        </Stack>
      );
    }

    if (!rankingResults.result) {
      return (
        <Typography variant="body2" color="text.secondary">
          No ranking executed yet.
        </Typography>
      );
    }

    const result = rankingResults.result;
    const itemCount = result.items?.length ?? 0;
    return (
      <Stack spacing={2}>
        <Button
          variant="outlined"
          startIcon={<CodeIcon />}
          onClick={handleOpenBackendCallDialog}
          fullWidth
          disabled={!rankingLastCall}
        >
          Backend Call
        </Button>

        <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
          <ArrowDownwardIcon color="action" />
        </Box>

        <Box>
          <Stack spacing={1}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2">Items ranked</Typography>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {itemCount}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2">Frontend</Typography>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {rankingResults.took_frontend || 0}ms
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2">Backend</Typography>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {result.took_backend || 0}ms
              </Typography>
            </Box>
          </Stack>
        </Box>
      </Stack>
    );
  };

  return (
    <>
      <Paper elevation={2} sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h6" gutterBottom>
          Information
        </Typography>

        <Box sx={{ mt: 2, flex: 1, overflow: 'auto' }}>
          {renderInfo()}
        </Box>

        <BackendCallDialog
          open={backendCallDialogOpen}
          onClose={handleCloseBackendCallDialog}
          apiCall={rankingLastCall}
          maxWidth="md"
        />
      </Paper>
    </>
  );
};

export default RankingInfoColumn;
